import React from 'react'

import TokenIcon from '@/components/tokens/TokenIconComponent'
import { cn } from '@/lib/utils'

interface DualIconProps {
  primaryIcon: string
  secondaryIcon: string
  className?: string
  primaryClassName?: string
  secondaryClassName?: string
  primaryName?: string
  secondaryName?: string
}

const DualIcon: React.FC<DualIconProps> = ({
  primaryIcon,
  secondaryIcon,
  className = '',
  primaryClassName = 'size-6 md:size-8 rounded-full',
  secondaryClassName = 'size-3 md:size-5 rounded-full border border-surface-hard left-2/3 top-3.5 md:top-1/2',
  primaryName,
  secondaryName,
}) => {
  return (
    <div className={cn('relative mr-1 md:mr-3', className)}>
      <TokenIcon symbol={primaryIcon} className={primaryClassName} name={primaryName} />
      <TokenIcon symbol={secondaryIcon} className={cn('absolute', secondaryClassName)} name={secondaryName} />
    </div>
  )
}

export default DualIcon
